export default __webpack_public_path__ + "static/media/message.f8271563.jpg";